import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import PoliticsAndProceduresServices from "./PoliticsAndProcedures.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getPoliticsAndProcedures = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_POLITICS_AND_PROCEDURES,
      payload: true,
    });
    const resp = await PoliticsAndProceduresServices.getPoliticsAndProcedures(filters);
    dispatch({
      type: actions.GET_POLITICS_AND_PROCEDURES,
      payload: {
        politicsAndProcedures: resp.data.data,
        politicsAndProceduresLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.POLITICS_AND_PROCEDURES_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.POLITICS_AND_PROCEDURES_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_POLITICS_AND_PROCEDURES,
      payload: false,
    });
  }
};

export const getPoliticsAndProceduresById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_POLITICS_AND_PROCEDURES,
      payload: true,
    });
    const resp = await PoliticsAndProceduresServices.getPoliticsAndProceduresById(id);
    dispatch({
      type: actions.GET_POLITICS_AND_PROCEDURES,
      payload: {
        politicsAndProcedure: resp.data
      },
    });
    dispatch({
      type: actions.POLITICS_AND_PROCEDURES_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.POLITICS_AND_PROCEDURES_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_POLITICS_AND_PROCEDURES,
      payload: false,
    });
  }
};

export const savePoliticsAndProcedures = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_POLITICS_AND_PROCEDURES,
      payload: true,
    });
    const resp = await PoliticsAndProceduresServices.savePoliticsAndProcedures(data);
    const { politicsAndProcedures, politicsAndProceduresLength } = getState().politicsAndProcedure;
    const _politicsAndProcedure = [...politicsAndProcedures, resp.data];
    dispatch({
      type: actions.GET_POLITICS_AND_PROCEDURES,
      payload: {
        politicsAndProcedures: _politicsAndProcedure,
        politicsAndProceduresLength: politicsAndProceduresLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.FORM_FAIL_JSON,
      payload: {},
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    let _message = {};
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            _message=ex.response.data
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
    dispatch({
      type: actions.FORM_FAIL_JSON,
      payload: _message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_POLITICS_AND_PROCEDURES,
      payload: false,
    });
  }
};

export const editPoliticsAndProcedures = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_POLITICS_AND_PROCEDURES,
      payload: true,
    });
    const resp = await PoliticsAndProceduresServices.editPoliticsAndProcedures(id, data);
    const { politicsAndProcedures, politicsAndProceduresLength } = getState().politicsAndProcedure;
    politicsAndProcedures[index] = resp.data;
    dispatch({
      type: actions.GET_POLITICS_AND_PROCEDURES,
      payload: {
        politicsAndProcedures: politicsAndProcedures,
        politicsAndProceduresLength: politicsAndProceduresLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    let _message = {};
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            _message=ex.response.data
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
    dispatch({
      type: actions.FORM_FAIL_JSON,
      payload: _message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_POLITICS_AND_PROCEDURES,
      payload: false,
    });
  }
};

export const deletePoliticsAndProcedures = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_POLITICS_AND_PROCEDURES,
      payload: true,
    });
    await PoliticsAndProceduresServices.deletePoliticsAndProcedures(id);
    const { politicsAndProcedures, politicsAndProceduresLength } = getState().politicsAndProcedure;
    politicsAndProcedures.splice(index, 1);
    dispatch({
      type: actions.GET_POLITICS_AND_PROCEDURES,
      payload: {
        politicsAndProcedures: politicsAndProcedures,
        politicsAndProceduresLength: politicsAndProceduresLength - 1,
      },
    });
    dispatch({
      type: actions.POLITICS_AND_PROCEDURES_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.POLITICS_AND_PROCEDURES_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_POLITICS_AND_PROCEDURES,
      payload: false,
    });
  }
};
